import React, { useEffect } from 'react';
import '../../../App.css';
import './Sculc2023.css';

import AOS from 'aos';
import 'aos/dist/aos.css';

const Sculc2023 = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <div className="sculc2023-page">
            <div className="sculc2023-header-container">
                <img
                    src="/images/sculc2023/image (18).png"
                    alt="Header"
                    className="sculc2023-header-image"
                />  
                <h1 className="sculc2023-title">Photos</h1>
            </div>
            <div className="sculc2023-navbar">
                <div className="sculc2023-navbar-container">
                    <a href="/sculc-2023" className="sculc2023-links">Home</a>
                    <a href="/sculc-2023-program" className="sculc2023-links">Programs</a>
                    <a href="/sculc-2023-schedule" className="sculc2023-links">Schedule</a>
                    <a href="/sculc-2023-presentation" className="sculc2023-links">Presentation</a>
                    <a href="/sculc-2023-photo" className="sculc2023-links">Photos</a>
                </div>
            </div>
            <div className="sculc2023-container">
                <div className="sculc2023-table-container">
                    <div className="sculc2023-image-thirds">
                        <img src="/images/sculc2023/image (1).png" alt="" width="100%" data-aos="fade-up" data-aos-once="true" data-aos-delay="0"></img>
                        <div style={{height: "3%"} }></div>
                        <img src="/images/sculc2023/image (13).png" alt="" width="100%" data-aos="fade-up" data-aos-once="true" data-aos-delay="500"></img>
                    </div>
                    <div className="sculc2023-image-two-thirds" data-aos="fade-up" data-aos-once="true" data-aos-delay="250">
                        <img src="/images/sculc2023/image (14) gen-expand.jpg" alt="" width="100%"></img>
                    </div>
                </div>
               
                <div className="sculc2023-table-container" data-aos="fade-up" data-aos-once="true" data-aos-delay="250">
                    <div className="sculc2023-image-half">
                        <p style={{ fontSize: "2.5em", color: "#4499cc" }} >Keynote Speaker: Daria Bahtina</p>
                        <br></br>
                        <p style={{ fontSize: "1.2em", textAlign: "left" }}>University of California, Los Angeles</p>
                        <br></br>
                        <p style={{ fontSize: "1.2em", textAlign: "left" }}>Ukraine in Transition: Language Shifts among Russian-Speaking Vloggers</p>
                    </div>
                    <div className="sculc2023-image-half">
                        <img src="/images/sculc2023/image (3).png" alt="" width="100%"></img>
                    </div>
                </div>
                
                <div className="sculc2023-table-container" data-aos="fade-up" data-aos-once="true" data-aos-delay="0">
                    <div className="sculc2023-image-half">
                        <img src="/images/sculc2023/image (2).png" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2023-image-half">
                        <img src="/images/sculc2023/image (4).png" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2023-table-container" data-aos="fade-up" data-aos-once="true" data-aos-delay="0">
                    <div className="sculc2023-image-half" style={{ textAlign: "center" }}>
                        <img src="/images/sculc2023/image (11).png" alt="" width="100%"></img>
                        <p style={{ color: "#4499cc", fontSize: "1.4em" , lineHeight: "3"}}>Katalina Peterson</p>
                        <p>'We Can Do This/Juntos Sí Podemos: COVID-19 PSAS in English and Spanish: A critical Discourse Analysis'</p>
                    </div>
                    <div className="sculc2023-image-half" style={{ textAlign: "center" }}>
                        <img src="/images/sculc2023/image (15).png" alt="" width="100%"></img>
                        <p style={{ color: "#4499cc", fontSize: "1.4em", lineHeight: "3" }}>Jacob Atticus Bushard</p>
                        <p>'Diving Into the Deep End of English Inflection'</p>
                    </div>
                </div>
                
                <div className="sculc2023-table-container">
                    <div className="sculc2023-image-thirds" style={{ textAlign: "center" }}>
                        <p style={{ color: "#4499cc", fontSize: "2em", lineHeight: "3" }}>Cedric Chan</p>
                        <p style={{fontSize: "1.2em", textAlign: "left"}}>'Quantifying Syntactic Complexity: Measuring Historical Patterns Through Inaugural Addresses'</p>
                    </div>
                    <div className="sculc2023-image-two-thirds">
                        <img src="/images/sculc2023/image (6).png" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2023-table-container">
                    <div className="sculc2023-image-half">
                        <img src="/images/sculc2023/image (7).png" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2023-image-half">
                        <img src="/images/sculc2023/image (8).png" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc2023-table-container">
                    <div className="sculc2023-image-two-thirds">
                        <img src="/images/sculc2023/image (16).png" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2023-image-thirds">
                        <img src="/images/sculc2023/image (5).png" alt="" width="100%"></img>
                        <div style={{ height: "3%" }}></div>
                        <img src="/images/sculc2023/image (17).png" alt="" width="100%"></img>
                    </div>
                    
                </div>
                <div className="sculc2023-table-container">
                    <div className="sculc2023-image-half">
                        <img src="/images/sculc2023/image (9).png" alt="" width="100%"></img>
                    </div>
                    <div className="sculc2023-image-half">
                        <img src="/images/sculc2023/image (10).png" alt="" width="100%"></img>
                    </div>
                </div>
                <div className="sculc-table-container">
                    <p style={{ color: "#4499cc", fontSize: "1.8em",  textAlign: "center", margin: "2em"}}>SCULC 2023 once again thanks all of its presenters, volunteers, and attendees for their participation and contribution to this conference.</p>
                </div>

            </div>
            
            <div style={{height: "5vh"} }></div>
                
        </div>
    );
};

export default Sculc2023;
